import React from 'react';
import { Box, Grid } from '@mui/material';
import { useStyles } from './styles';
import clsx from 'clsx';
import { get } from 'global/lib/lodash';

const SidebarXS = 3;

export const GridContainer = (props) => {
  const { fullWidth, ...rest } = props;
  const classes = useStyles();
  return (
    <Grid spacing={0} container className={clsx(classes.border, fullWidth ? undefined : classes.gridContainer)} {...rest}>
      {props.children}
    </Grid>
  );
};

export const LeftSideBar = (props) => {
  const { hidden, children } = props;
  const classes = useStyles();
  const { boxProps, ...rest } = props;

  return hidden ? null : (
    <Grid {...rest} item className={clsx(classes.padd0, classes.border, classes.padTop)} container alignItems="center" direction="column" xs={SidebarXS}>
      <Box {...get(props, 'boxProps', {})} displayPrint="none" className={classes.sidebarWidth}>
        {children}
      </Box>
    </Grid>
  );
};

export const CenterContent = (props) => {
  const { children, fullWidth, selfCenter, ignoreRight, ...rest } = props;

  const overflowHidden = get(props, 'overflowHidden', false);
  const classes = useStyles();

  const grids = fullWidth
    ? {
        xs: 12,
      }
    : ignoreRight
    ? {
        xs: 12,
        sm: 12,
        md: 12,
        lg: 12 - SidebarXS,
        xl: 12 - SidebarXS,
      }
    : {
        xs: 12,
        sm: 12,
        md: 12,
        lg: 12 - SidebarXS,
        xl: 12 - SidebarXS * 2,
      };

  return (
    <Grid className={clsx(classes.padd0, classes.border, selfCenter && classes.selfCenter, overflowHidden && classes.overflowHidden, fullWidth && classes.contentWidth)} item {...grids} {...rest}>
      {children}
    </Grid>
  );
};

export const RightSideBar = (props) => {
  const { children, hidden } = props;
  const classes = useStyles();

  return hidden ? null : (
    <Grid sx={{ display: { xs: 'none', sm: 'none', md: 'none', lg: 'none', xl: 'block' } }} className={[classes.padd0, classes.border].join(' ')} item xl={SidebarXS}>
      {children}
    </Grid>
  );
};

export const PhotosGrid = (props) => {
  return (
    <Grid container>
      <Grid item xs={1} lg={2} />
      <Grid item xs={10} lg={8}>
        {props.children}
      </Grid>
    </Grid>
  );
};
